import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    marginTop: theme.spacing(2.5)
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    flexBasis: 'auto',
    justifyContent: 'space-between',
    margin: `${theme.spacing(1)}px 0px ${theme.spacing(2)}px 0px`
  },
  tableRow: {
    height: 50,
    '& > td': {
      fontFamily: 'National',
      fontSize: 15,
      letterSpacing: 0,
      lineHeight: '21px',
      border: 0,
      padding: `${theme.spacing(0.8)}px ${theme.spacing(1.5)}px ${theme.spacing(0.8)}px 0px`
    },
    '& > td:first-child': {
      paddingLeft: theme.spacing(2)
    }
  },
  headerRow: {
    height: 50,
    backgroundColor: '#F2F4F9',
    '& > th': {
      fontSize: '10px',
      fontWeight: 'bold',
      letterSpacing: '2px',
      lineHeight: '13px',
      border: 0,
      padding: `${theme.spacing(0.8)}px ${theme.spacing(1.5)}px ${theme.spacing(0.8)}px 0px`,
      textTransform: 'uppercase'
    },
    '& > th:first-child': {
      paddingLeft: theme.spacing(2)
    }
  },
  panel: {
    backgroundColor: '#E4E8F1',
    '& > div': {
      alignItems: 'center',
      margin: 0
    },
    '& > div.Mui-expanded': {
      margin: 0
    },
    '&.Mui-expanded': {
      minHeight: 48
    }
  },
  details: {
    padding: 0
  },
  quartileName: {
    flexBasis: '15%',
    flexShrink: 0
  },
  learnersCount: {
    flexBasis: '33.33%',
    flexShrink: 0,
    color: '#8688A1',
    fontSize: 12
  },
  root: {
    width: '100%'
  }
}))
